module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "normal-question-detail"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Manage')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/normal_question"
    }
  }, [_vm._v(_vm._s(_vm.$t('Normal Questions List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Normal Questions Detail')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Normal Questions Detail')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-xs-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])])])]), _vm._l((_vm.questions), function(question, index) {
    return _c('div', {
      staticClass: "row margin-top"
    }, [_c('div', {
      staticClass: "col-xs-2 text-right"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label"
    }, [_c('span', [_vm._v("評価項目 " + _vm._s(index + 1))])])])]), _c('div', {
      staticClass: "col-xs-10"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.newLineContent(question.content))
      }
    })])])])
  }), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Back')))])])])])], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 text-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_c('span', [_vm._v("タイトル")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06bab674!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/normal-question-detail.pug
// module id = 773
// module chunks = 1